import AnimatedSection from "./AnimatedSection";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import {
  Search, ClipboardList, Ship, Plane, Truck, Shield, MapPin, Calculator,
} from "lucide-react";

const iconComponents = { Search, ClipboardList, Ship, Plane, Truck, Shield, MapPin, Calculator };

const ServicesGrid = () => {
  const { lang } = useLang();
  const t = translations[lang].services;

  return (
    <section id="services" data-testid="services-section" className="bg-navy py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <AnimatedSection>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-electric-light mb-4 font-body">
            {t.overline}
          </p>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white font-heading mb-16 max-w-2xl">
            {t.headline}
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {t.items.map((item, i) => {
            const Icon = iconComponents[item.icon];
            return (
              <AnimatedSection key={i} delay={i * 0.05}>
                <div data-testid={`service-card-${i}`} className="service-card-glass rounded-2xl p-6 cursor-default text-center">
                  <Icon size={28} className="text-electric-light mb-3 mx-auto" />
                  <p className="text-white/90 font-medium text-sm font-body">{item.title}</p>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
